"use client";

import { useEffect, useState } from "react";
import styles from "./DrawerIframe.module.scss";
import classNames from "classnames";
import { TTP_LMS_URL } from "../../../config";
import { encryptAES } from ".";
import { useSelector } from "react-redux";
import useRedirectTopListener from "./useRedirectTopListener";

const prepareOfffcourseParams = (user, token, lng) => {
  let params = {};
  if (user && token) {
    params["auth"] = {
      id: user.id,
      token,
    };
  }
  if (lng) {
    params["preferences"] = { language: lng };
  }

  params["app"] = "UA_EVENT";

  return encryptAES(JSON.stringify(params));
};

export default function EventIframe({ lng, clientId }) {
  const [iframeSrc, setIframeSrc] = useState("");
  const [loadingIframe, setLoadingIframe] = useState(true);
  const [modalOpened, setModalOpened] = useState(false);

  const { token, user } = useSelector((state) => state.auth);
  const selectedToken = token;

  useRedirectTopListener();

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.event === "OPEN_MODAL") {
        setModalOpened(true);
      }

      if (event.data?.event === "CLOSE_MODAL") {
        setModalOpened(false);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  const updateIframeSrc = () => {
    if (!token) {
      return;
    }

    const params = prepareOfffcourseParams(user, token, lng);

    let iframeSrc =
      `${TTP_LMS_URL}/${lng}/ua-event/${clientId}` +
      "?params=" +
      encodeURIComponent(params);

    setIframeSrc(iframeSrc);
    setLoadingIframe(true);
  };

  useEffect(() => {
    updateIframeSrc();
  }, [lng, selectedToken]);

  return (
    <div
      className={classNames(styles.wrapper, modalOpened && styles.modalOpen)}
    >
      {/* {loadingIframe && <Loader id="iframe-loader" />} */}
      <iframe
        id="offfcourse-iframe"
        src={iframeSrc}
        className={styles.iframe}
        allow="camera;microphone;autoplay;fullscreen;payment"
        onLoad={() => {
          setLoadingIframe(false);
        }}
      />
    </div>
  );
}
